var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "progress-bar-container flex flex-auto flex-row" },
    [
      _vm._l(_vm.currentStep, function (index) {
        return _c("div", { key: index, staticClass: "flex-auto bar-filled" })
      }),
      _vm._v(" "),
      _vm._l(_vm.totalSteps - _vm.currentStep, function (index) {
        return _c("div", {
          key: index + _vm.currentStep,
          staticClass: "flex-auto bar-empty",
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }